var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDownloadCloudArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.5C8.21698 0.5 6.6397 1.20057 5.5072 2.17727C4.54981 3.00296 3.85599 4.07713 3.67778 5.15625C1.58233 5.6189 0 7.44389 0 9.64773C0 12.2075 2.13442 14.25 4.72656 14.25H9.375V7.375C9.375 7.02982 9.65482 6.75 10 6.75C10.3452 6.75 10.625 7.02982 10.625 7.375V14.25H15.8594C18.1279 14.25 20 12.4619 20 10.2159C20 8.1707 18.4476 6.50513 16.4571 6.22373C16.1541 2.9993 13.3628 0.5 10 0.5Z",
    fill: "#1C2743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55806 20.3169C9.80214 20.561 10.1979 20.561 10.4419 20.3169L14.1919 16.5669C14.436 16.3229 14.436 15.9271 14.1919 15.6831C13.9479 15.439 13.5521 15.439 13.3081 15.6831L10.625 18.3661V14.25H9.375V18.3661L6.69194 15.6831C6.44786 15.439 6.05214 15.439 5.80806 15.6831C5.56398 15.9271 5.56398 16.3229 5.80806 16.5669L9.55806 20.3169Z",
    fill: "#1C2743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDownloadCloudArrow);
export default __webpack_public_path__ + "static/media/ico-download-cloud-arrow.183fd6ccf5668fed23617d9de9fbb87d.svg";
export { ForwardRef as ReactComponent };